const portoData = [
  //This Medium Section
  {
    title: 'Phishing Email Classification using only URL Features',
    desc: 'A Medium article of Phishing Email Classification using only URL Features. This exploration highlights the potency of URL-based indicators in identifying and neutralizing phishing threats.',
    img: 'https://miro.medium.com/v2/resize:fit:828/format:webp/1*p4P0-bkHTfBqjKS6n55ytg.png',
    url: 'https://medium.com/@p98718/phishing-email-classification-using-only-url-features-cb3df668a5c9',
    type: 1,
  },
  {
    title: 'Feature Importance and Binary Classification using PyCaret',
    desc: 'A Medium article of binary classification using the power of Feature Importance analysis with PyCaret. Understanding the significance of features can elevate your decision-making processes to new heights.',
    img: 'https://miro.medium.com/v2/resize:fit:828/format:webp/1*y3aROTeP9k5t5O4vlZ2HBg.png',
    url: 'https://medium.com/@p98718/feature-importance-and-binary-classification-using-pycaret-a94b9a6a5b03',
    type: 1,
  },

  //This Vercel App Section
  {
    title: 'Terik JKT48',
    desc: "Embark on a musical journey with the Capital Group Idol Lyrics & Song Guess Game, a fanmade web app dedicated to the chart-topping tunes of your beloved idol group. Whether you're a dedicated fan or a newcomer to their mesmerizing melodies, this app is your ticket to a thrilling lyrics and song guessing experience!",
    img: '/porto/porto3.png',
    url: 'https://terikjkt48.vercel.app/',
    type: 2,
  },
  {
    title: 'Searchvie - Search Movie',
    desc: 'Embark on a cinematic journey with my Movie Search App, a beautifully crafted web application powered by ReactJS and DaisyUI. This dynamic platform seamlessly integrates with the IMDb API, bringing the vast world of movies to your fingertips.',
    img: '/porto/porto1.png',
    url: 'https://searchvie.vercel.app/',
    type: 2,
  },
  {
    title: 'Memoaraku - Instagram Gallery',
    desc: 'An innovative gallery web app powered by ReactJS and seamlessly integrated with the Instagram API. Immerse yourself in a world of captivating images, dynamic data, and a user experience tailored to elevate your visual exploration.',
    img: '/porto/porto2.png',
    url: 'https://memoaraku.vercel.app/',
    type: 2,
  },
  {
    title: 'To-Do App',
    desc: 'In the first chapter of my coding chronicles, there exists a milestone—a beacon that heralds the inception of my React journey. Behold, my very first creation in the realm of React—a To-Do List app that stands as both witness and testament to the nascent steps taken on this path of digital mastery.',
    img: '/porto/porto4.png',
    url: 'https://todo-react-afadhilen.vercel.app/',
    type: 2,
  },
]

export default portoData
